import React from 'react';

const BackgroundEffects = () => (
  <>
    <div className="noise-overlay" />
    <div className="grid-bg" />
  </>
);

export default BackgroundEffects;
